import React, { useState } from "react";
import { Select, Input, Tooltip, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setWidgetChartName,
  setWidgetLegendPosition,
  setChartYAxisMode,
  setWidgetNumberTopPosts,
  setShowLegend,
} from "../../../redux/actions/WidgetMaker/GraphConfig";
import { useMemo } from "react";
import { callNotification } from "../../../redux/constants";

const { Option } = Select;

const BasicSetting = () => {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const authParams = useSelector((state) => state.Authentication.authParams);
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const chartLegendPosition = useSelector(
    (state) =>
      state?.GraphConfig?.widgetGraphConfig?.chart_property?.legend_position
  );
  const chartName = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig?.chart_property?.chart_name
  );
  const graphConditions = useSelector(
    (state) => state?.apiCall?.graphConditions
  );

  const [checkLegend, setCheckLegend] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_property?.show_legend
  );

  const handleChartName = (e) => {
    setName(e.target.value);
    dispatch(setWidgetChartName(e.target.value, widgetGraphConfig));
  };

  const handleLegendPosition = (value) => {
    dispatch(setWidgetLegendPosition(value, widgetGraphConfig));
  };

  const handleShowLegend = (e) => {
    setCheckLegend(!checkLegend);
    dispatch(setShowLegend(e.target.checked, widgetGraphConfig));
  };

  const handleNumberTopPosts = (value) => {
    dispatch(setWidgetNumberTopPosts(value, widgetGraphConfig));
  };

  const handleChartYAxisMode = (value, i) => {
    dispatch(setChartYAxisMode(value, widgetGraphConfig));
  };
  const getModeDisabledStatus = (y_axis, y_axis_settings) => {
    let flrSeriesExists = false;
    let allSeriesIsFLR = true;
    let ySeriesFromConfig = Object?.entries(y_axis);
    ySeriesFromConfig?.map((ySeries, i) => {
      if (ySeries?.attribute || ySeries?.[1]?.attribute) {
        if (
          !(
            (ySeries?.attribute &&
              graphConditions?.["time-label-attrs"]?.includes(
                ySeries?.attribute
              )) ||
            graphConditions?.["time-label-attrs"]?.includes(
              ySeries?.[1]?.attribute
            ) ||
            (ySeries?.attribute &&
              graphConditions?.["ticket-time-label-attrs"]?.includes(
                ySeries?.attribute
              )) ||
            graphConditions?.["ticket-time-label-attrs"]?.includes(
              ySeries?.[1]?.attribute
            )
          )
        ) {
          allSeriesIsFLR = false;
        }
        if (
          ySeries?.attribute &&
          (graphConditions?.["time-label-attrs"]?.includes(
            ySeries?.attribute
          ) ||
            graphConditions?.["ticket-time-label-attrs"]?.includes(
              ySeries?.attribute
            ))
        ) {
          flrSeriesExists = true;
        } else if (
          graphConditions?.["time-label-attrs"]?.includes(
            ySeries?.[1]?.attribute
          ) ||
          graphConditions?.["ticket-time-label-attrs"]?.includes(
            ySeries?.[1]?.attribute
          )
        ) {
          flrSeriesExists = true;
        }
      }
    });

    // check for y_axis_settings
    let disableYAxisMode =
      Array.isArray(y_axis_settings) &&
      !(
        (y_axis_settings?.[0]?.y_axis_scale !== "log" &&
          y_axis_settings?.[1]?.y_axis_scale !== "log") ||
        (y_axis_settings?.[0]?.y_axis_scale === "log" &&
          y_axis_settings?.[1]?.y_axis_scale === "log")
      );
    let modeStatus = flrSeriesExists
      ? allSeriesIsFLR
        ? false
        : true
      : disableYAxisMode;
    if (modeStatus && widgetGraphConfig?.chart_property?.y_axis_mode == "1") {
      dispatch(setChartYAxisMode("2", widgetGraphConfig));
    }
    return {
      status: modeStatus,
      tooltip: flrSeriesExists
        ? allSeriesIsFLR
          ? ""
          : "FLR and other attributes can not be latched to single axis"
        : disableYAxisMode
        ? "To enable this select the same visualization scale"
        : "",
    };
  };
  const modeDisabledStatus = useMemo(
    () =>
      getModeDisabledStatus(
        widgetGraphConfig?.y_axis,
        widgetGraphConfig?.y_axis_settings
      ),
    [widgetGraphConfig?.y_axis, widgetGraphConfig?.y_axis_settings]
  );
  return (
    <>
      <div className="position-relative chartName floating-label-group header-brands mt-3">
        <Input
          required
          id="outlined-required"
          //label="Chart Name"
          //placeholder="Enter chart name"
          value={chartName}
          // fullWidth={true}
          // size="small"
          onChange={handleChartName}
          InputLabelProps={{
            shrink: true,
          }}
          maxLength={100}
          //inputProps={{ maxLength: 50 }}
          className="mb-15 border-radius-4 border-color"
          autocompleteDisabled={true}
          autocomplete="new-password"
        />
        <label className="portlet-label floating-label">
          Chart Name <span className="error">*</span>
        </label>
        <span
          className="text-gray position-absolute font-size12"
          style={{
            right: "0.3rem",
            bottom: "1.3rem",
          }}
        >
          {chartName?.length > 0 ? chartName?.length : "0"}/100
        </span>
      </div>

      {/* {(widgetGraphConfig?.chart_type === "pie" ||
				widgetGraphConfig?.chart_type === "donut") && (
				<div className="floating-label-group header-brands mb-15">
					<Select
						className="w-100 text_regular"
						placeholder="Color Pattern"
						// defaultValue="Linear"
						onChange={handleChange}
					>
						<Option value="Shades of sentiments">Shades of sentiments</Option>
						<Option value="Single Axis">Single Axis</Option>
						<Option value="Left">Multiple</Option>
						<Option value="Right">Right</Option>
					</Select>
					<label
						className="portlet-label floating-label bg__white font-size12"
						style={{ top: "-0.8rem" }}
					>
						Color Pattern
					</label>
				</div>
			)} */}
      {widgetGraphConfig?.chart_type === "kpi" ||
      widgetGraphConfig?.chart_type === "rich-text" ||
      widgetGraphConfig?.chart_type === "heat" ||
      widgetGraphConfig?.chart_type === "wordcloud" ||
      widgetGraphConfig?.chart_type === "grid" ||
      widgetGraphConfig?.chart_type === "map" ||
      widgetGraphConfig?.chart_type === "sunburst" ||
      widgetGraphConfig?.chart_type === "multilayer-map" ||
      widgetGraphConfig?.chart_type === "heatmap" ||
      widgetGraphConfig?.chart_type === "post-card" ||
      widgetGraphConfig?.chart_type === "survey-card" ||
      widgetGraphConfig?.chart_type === "review-card" ||
      widgetGraphConfig?.chart_type === "author-card" ||
      widgetGraphConfig?.chart_type === "pivot-grid" ||
      widgetGraphConfig?.chart_type === "prolific-user" ||
      widgetGraphConfig?.chart_type === "treemap" ||
      widgetGraphConfig?.chart_type === "sankey" ||
      widgetGraphConfig?.chart_type === "cluster-chart" ? (
        ""
      ) : (
        <>
          {(((widgetGraphConfig?.chart_type === "combination" ||
            widgetGraphConfig?.chart_type === "bar" ||
            widgetGraphConfig?.chart_type === "lollipop" ||
            widgetGraphConfig?.chart_type === "horizontal-bar" ||
            widgetGraphConfig?.chart_type === "area" ||
            widgetGraphConfig?.chart_type === "line") &&
            Object.entries(widgetGraphConfig?.y_axis)?.filter(
              (el) => el[1]?.attribute
            )?.length > 1) ||
            widgetGraphConfig?.breakdown_by?.length ||
            widgetGraphConfig?.chart_type === "pie" ||
            widgetGraphConfig?.chart_type === "donut" ||
            widgetGraphConfig?.chart_type === "bubble") && (
            <>
              <div className="floating-label-group header-brands mb-15">
                <Select
                  className="w-100"
                  defaultValue={chartLegendPosition}
                  onChange={handleLegendPosition}
                  dropdownClassName={
                    authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                  }
                >
                  <Option value="top">Top</Option>
                  <Option value="bottom">Bottom</Option>
                  <Option value="left">Left</Option>
                  <Option value="right">Right</Option>
                </Select>
                <label
                  className="portlet-label floating-label bg__white font-size12"
                  style={{ top: "-0.8rem" }}
                >
                  Legend Position
                </label>
              </div>
              <Checkbox
                value="Gradient Color"
                className="text_regular m-0 mb-2 d-flex align-items-start"
                onChange={handleShowLegend}
                checked={checkLegend}
              >
                Show Legend
              </Checkbox>
            </>
            // add the Show Legend toggle here
          )}

          {widgetGraphConfig?.chart_type === "combination" && (
            <div className="floating-label-group header-brands mb-15">
              <Tooltip title={modeDisabledStatus?.tooltip}>
                <Select
                  defaultValue="2"
                  onChange={handleChartYAxisMode}
                  className="w-100"
                  dropdownClassName={
                    authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                  }
                  value={
                    widgetGraphConfig?.chart_property?.y_axis_mode == "1"
                      ? "1"
                      : "2"
                  }
                  disabled={modeDisabledStatus?.status}
                >
                  <Option value="2">Dual Axis</Option>
                  <Option value="1">Single Axis</Option>
                </Select>
              </Tooltip>
              <label
                className="portlet-label floating-label bg__white font-size12"
                style={{ top: "-0.8rem" }}
              >
                Y-axis mode
              </label>
            </div>
          )}
        </>
      )}

      {widgetGraphConfig?.chart_type === "post-card" &&
        widgetGraphConfig?.chart_settings?.top_posts_in_cards && (
          <>
            <div className="floating-label-group header-brands mb-15">
              <p className="post_heading_text">Post Filter</p>
              <p className="post_note_text">
                * You can select the number of post displayed for each brand
              </p>
              <Select
                className="w-100"
                defaultValue={
                  widgetGraphConfig?.chart_property?.no_of_top_posts
                }
                onChange={handleNumberTopPosts}
                dropdownClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                <Option value={1}>Top 1 post</Option>
                <Option value={3}>Top 3 post</Option>
                <Option value={5}>Top 5 post</Option>
              </Select>
            </div>
          </>
        )}
    </>
  );
};

export default BasicSetting;
